import type { ReactNode } from 'react';

export const symbol_mail_lock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M143-160q-25 0-44-18.5T80-220v-520q0-23 18-41.5t42-18.5h680q23 0 41.5 18.5T880-740v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-120L496-473q-4 2-7.5 3t-8.5 1q-5 0-8.5-1t-7.5-3L140-680v460h500q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H143Zm337-367 340-213H140l340 213ZM140-220v-460 2-40.47 1.47-23 23-1.28V-677v-3 460Zm625 60q-14 0-24.5-10.5T730-195v-120q0-14 11.5-24.5T770-350v-45q0-30.94 22.04-52.97 22.05-22.03 53-22.03Q876-470 898-447.97T920-395v45q17 0 28.5 10.5T960-315v120q0 14-10.5 24.5T925-160H765Zm35-190h90v-44.91Q890-414 877.09-427q-12.91-13-32-13T813-427.06q-13 12.93-13 32.06v45Z"
		/>
	</svg>
);
